import { Button, Stack, Switch } from '@mui/material';
import { ArrowCounterClockwiseIcon } from '@phosphor-icons/react';
import { useState } from 'react';

import { Text, api, isDefined } from 'common';

import { FilterOperationFields } from './FilterOperationFields.tsx';
import { SortBlockFormFields } from './SortFormFields.tsx';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField.ts';
import { FILTER_BLOCK_MATCH_RULE_NAMES } from '../FilterList/constants.ts';

const FilterMatchRule = api.FlowDefinition.PatientDataStore.FilterAndSortConfig.FilterMatchRule;
type FilterOperation = api.FlowDefinition.PatientDataStore.FilterAndSortConfig.FilterOperation;
type FilterAndSortConfig = typeof api.FlowDefinition.PatientDataStore.FilterAndSortConfig;

export function FilterAndSortBlockFormFields() {
  const { value: filterMatchRule, setValue: setFilterMatchRule } = useSelectedNodeField<
    (typeof FilterMatchRule)[keyof typeof FilterMatchRule]
  >('config.baseFilters.filterConfig.matchRule');
  const { value: filterOperations, setValue: setFilterOperations } = useSelectedNodeField<
    FilterOperation[]
  >('config.baseFilters.filterConfig.filterOperations');
  const { value: basicFilter } = useSelectedNodeField<FilterAndSortConfig>('config.baseFilters');
  const [isAdvancedVisible, setIsAdvancedVisible] = useState(
    isDefined(basicFilter) && Object.keys(basicFilter).length > 0
  );

  return (
    <Stack gap={1}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Text variant="heading5" bold>
          Advanced
        </Text>
        <Switch
          checked={isAdvancedVisible}
          onChange={() => {
            setIsAdvancedVisible(!isAdvancedVisible);
            if (!isAdvancedVisible && filterOperations?.length) {
              // remove all filter operations
              setFilterOperations([]);
            }
          }}
        />
      </Stack>

      {isAdvancedVisible && (
        <Stack gap={2}>
          <Stack direction="row" gap={0.5} alignItems="center">
            <Text variant="heading5" bold>
              Filter Operations
            </Text>
            {!!filterOperations?.length && (
              <Button
                variant="text"
                size="small"
                sx={{
                  minWidth: 'unset',
                  paddingY: 0,
                  paddingX: 0.25,
                  gap: 0.5,
                  fontSize: (theme) => theme.typography.h4.fontSize,
                  lineHeight: (theme) => theme.typography.h4.lineHeight,
                }}
                onClick={() => {
                  setFilterMatchRule(
                    filterMatchRule === FilterMatchRule.All
                      ? FilterMatchRule.Any
                      : FilterMatchRule.All
                  );
                }}
              >
                {'match ' + FILTER_BLOCK_MATCH_RULE_NAMES[filterMatchRule ?? FilterMatchRule.All]}
                <ArrowCounterClockwiseIcon size={12} />
              </Button>
            )}
          </Stack>
          <Stack gap={2}>
            <FilterOperationFields setFilterMatchRule={setFilterMatchRule} />
            <SortBlockFormFields />
          </Stack>
        </Stack>
      )}
    </Stack>
  );
}
